(ns client-portal.client.voice-insights.views
  (:require [client-portal.client.layout :as l]
            [shared.core.reactive :as re]
            [client-portal.client.voice-insights.concept.views :as vi.concept]
            [client-portal.client.voice-insights.restaurant-insight.views :as vi.restaurant-insight]
            [shared.core.util :as util]))


(defn root [_]
  (let [current-concept-id- (re/subscribe [:concepts/current-concept-id-])
        locations- (re/subscribe [:locations/by-current-concept-id-])]
    (re/create-class
      {:component-did-mount (fn [_]
                              (re/dispatch [:voice-insights/initialize]))
       :reagent-render
       (fn [{:keys [lid] :as args}]
         (let [concept-id? (not (nil? @current-concept-id-))
               lid (or lid (when (some-> (util/when-not-loading @locations-) (count) (= 1))
                             (:id (first @locations-))))
               location-id? (not (nil? lid))]
           [l/logged-in-with-header-nav-vi (merge args {:concept-dropdown? true
                                                        :location-dropdown? true})
            (cond
              (and concept-id? location-id?)
              [vi.restaurant-insight/dashboard]

              concept-id?
              [vi.concept/dashboard]

              :else
              [:div {:style {:display :flex
                             :flex-direction :column
                             :width "100%"
                             :min-height "100%"}}])]))})))
